module.exports = __webpack_public_path__ + "static/media/aeps_nav.a52bdfed.svg";